module.exports = __webpack_public_path__ + "static/media/mic.232d5373.png";